import { useTranslation } from 'react-i18next'
import Actions from './actions'
import Wallet from './wallet'
import { ReactComponent as Logo } from "@assets/logo/M_WHITE_LOGO_FULL.svg";
import { IconMenu2 } from "@tabler/icons-react";
import { Button } from "@fragments";
import { useSidebar } from '../Sidebar/SidebarContext'

import './styles.scss'


export default function Header() {
    const { t } = useTranslation('shell')
    const { collapsed, isMobile, toggleSidebar } = useSidebar()

    return (
        <div className="cs-header">
            <div className="cs-header-left">
                {isMobile && (
                    <Button
                        color="overlay"
                        variant="rounded"
                        icon={<IconMenu2 />}
                        onClick={toggleSidebar}
                        tooltip={t('actions.openMenu')}
                    />
                )}
                {(collapsed || isMobile) && (
                    <Logo className="cs-header-logo" />
                )}
                {!isMobile && <Wallet />}
            </div>
            <Actions />
        </div>
    )
}
